(function () {
    'use strict';

    const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

    // ============================================================
    // FRAME SEQUENCE SCROLL (for transparent backgrounds)
    // ============================================================
    function initScrollFrameSequence(section) {
        const canvas = section.querySelector('.video-scroll__canvas');
        const poster = section.querySelector('.video-scroll__poster');
        const imagesBottom = section.querySelectorAll('.section__image-bottom');

        if (!canvas) return;

        const frameCount = parseInt(canvas.dataset.frameCount) || 140;
        const cdnBaseUrl = canvas.dataset.cdnBaseUrl || '';

        if (!cdnBaseUrl) {
            console.warn('[video-scroll] CDN base URL not set');
            return;
        }

        const ctx = canvas.getContext('2d');
        const frames = [];
        let imagesLoaded = 0;
        let currentFrame = 0;
        let ticking = false;
        let hasStartedScrolling = false;
        let imageBottomActivated = false;

        // Preload all frames
        for (let i = 1; i <= frameCount; i++) {
            const img = new Image();
            const frameNumber = String(i).padStart(4, '0'); // 0001, 0002, etc.
            img.src = `${cdnBaseUrl}/${frameNumber}.png`;

            img.onload = function () {
                imagesLoaded++;

                // Set canvas size based on first image
                if (imagesLoaded === 1) {
                    canvas.width = img.width;
                    canvas.height = img.height;
                }
            };

            img.onerror = function () {
                console.warn(`[video-scroll] Failed to load frame: ${img.src}`);
            };

            frames.push(img);
        }

        function getMetrics() {
            const spacer = section.querySelector('.video-scroll__spacer');

            // Position absolue de la section (pas du spacer, à cause des marges négatives)
            const sectionRect = section.getBoundingClientRect();
            const sectionTop = window.scrollY + sectionRect.top;

            // Hauteur du spacer pour le bas
            const spacerRect = spacer.getBoundingClientRect();
            const spacerTop = window.scrollY + spacerRect.top;
            const spacerBottom = spacerTop + spacerRect.height;

            // L'animation commence au début de la section
            const startScroll = sectionTop;

            // L'animation se termine 20px avant que le bas de la fenêtre atteigne le bas du spacer
            const endScroll = spacerBottom - window.innerHeight - 20;

            const totalScroll = Math.max(1, endScroll - startScroll);

            return { sectionTop: startScroll, totalScroll };
        }

        function updateFromScroll() {
            if (imagesLoaded === 0) return;

            const { sectionTop, totalScroll } = getMetrics();
            const scrollY = window.scrollY || window.pageYOffset;

            // Progress va de 0 à 1 sur toute la hauteur de scroll disponible
            const progress = clamp((scrollY - sectionTop) / totalScroll, 0, 1);

            // Hide poster when animation starts (progress > 0.01 pour éviter le flicker)
            if (!hasStartedScrolling && progress > 0.01) {
                hasStartedScrolling = true;
                if (poster) poster.classList.add('is-hidden');
            }

            // Activer/Désactiver les images du bas selon le progress
            if (imagesBottom.length > 0) {
                if (progress > 0.99 && !imageBottomActivated) {
                    imageBottomActivated = true;
                    imagesBottom.forEach(img => img.classList.add('active'));
                } else if (progress <= 0.98 && imageBottomActivated) {
                    imageBottomActivated = false;
                    imagesBottom.forEach(img => img.classList.remove('active'));
                }
            }

            const frameIndex = Math.min(
                Math.floor(progress * frameCount),
                frameCount - 1
            );

            if (frameIndex !== currentFrame && frames[frameIndex] && frames[frameIndex].complete) {
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(() => {
                        currentFrame = frameIndex;
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        ctx.drawImage(frames[frameIndex], 0, 0, canvas.width, canvas.height);
                        ticking = false;
                    });
                }
            }
        }

        // Events
        window.addEventListener('scroll', updateFromScroll, { passive: true });
        window.addEventListener('resize', () => {
            requestAnimationFrame(updateFromScroll);
        });

        // Intersection observer to pause when out of viewport
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        updateFromScroll();
                    }
                });
            },
            { threshold: 0 }
        );
        io.observe(section);
    }

    function initScrollVideo(section) {
        // Récupérer la vidéo (Shopify <video> généré ou balise manuelle)
        const video =
            section.querySelector('video, .video-scroll__video') ||
            section.querySelector('video');

        const poster = section.querySelector('.video-scroll__poster');
        const imagesBottom = section.querySelectorAll('.section__image-bottom');

        if (!video) return;

        // Empêcher la lecture automatique "classique"
        try { video.pause(); } catch (e) { }

        let duration = 0;
        let ticking = false;
        let imageBottomActivated = false;

        // Calculs de repères absolus pour éviter les erreurs dues au sticky
        function getMetrics() {
            const spacer = section.querySelector('.video-scroll__spacer');

            // Position absolue de la section (pas du spacer, à cause des marges négatives)
            const sectionRect = section.getBoundingClientRect();
            const sectionTop = window.scrollY + sectionRect.top;

            // Hauteur du spacer pour le bas
            const spacerRect = spacer.getBoundingClientRect();
            const spacerTop = window.scrollY + spacerRect.top;
            const spacerBottom = spacerTop + spacerRect.height;

            // L'animation commence au début de la section
            const startScroll = sectionTop;

            // L'animation se termine 20px avant que le bas de la fenêtre atteigne le bas du spacer
            const endScroll = spacerBottom - window.innerHeight - 20;

            const totalScroll = Math.max(1, endScroll - startScroll);

            return { sectionTop: startScroll, totalScroll };
        }

        function updateFromScroll() {
            const { sectionTop, totalScroll } = getMetrics();
            const scrollY = window.scrollY || window.pageYOffset;
            const progress = clamp((scrollY - sectionTop) / totalScroll, 0, 1);

            // Activer/Désactiver les images du bas selon le progress
            if (imagesBottom.length > 0) {
                if (progress > 0.99 && !imageBottomActivated) {
                    imageBottomActivated = true;
                    imagesBottom.forEach(img => img.classList.add('active'));
                } else if (progress <= 0.98 && imageBottomActivated) {
                    imageBottomActivated = false;
                    imagesBottom.forEach(img => img.classList.remove('active'));
                }
            }

            if (duration > 0 && !isNaN(duration)) {
                const targetTime = duration * progress;

                // Réduction des saccades: on ne pousse currentTime qu'en rAF
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(() => {
                        try {
                            // Évite des micro-écarts coûteux en énergie
                            if (Math.abs(video.currentTime - targetTime) > 0.03) {
                                video.currentTime = targetTime;
                            }
                        } catch (e) { }
                        ticking = false;
                    });
                }
            }
        }

        // Quand la durée est prête
        function onMetadata() {
            duration = Number(video.duration) || 0;
            if (poster) poster.classList.add('is-hidden');
            updateFromScroll();
        }

        // Fallback: Safari iOS aime bien "loadeddata"
        video.addEventListener('loadedmetadata', onMetadata, { once: true });
        video.addEventListener('loadeddata', () => {
            if (!duration) onMetadata();
        }, { once: true });

        // Si la durée est déjà prête (mise en cache)
        if (!isNaN(video.duration) && video.duration > 0) {
            duration = Number(video.duration);
            if (poster) poster.classList.add('is-hidden');
            // Premier positionnement
            requestAnimationFrame(updateFromScroll);
        }

        // Events
        window.addEventListener('scroll', updateFromScroll, { passive: true });
        window.addEventListener('resize', () => {
            // Recalcule au prochain frame
            requestAnimationFrame(updateFromScroll);
        });

        // Bonus: mettre en pause quand la section sort du viewport
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        try { video.pause(); } catch (e) { }
                    }
                });
            },
            { threshold: 0 }
        );
        io.observe(section);
    }

    // Boot sur toutes les sections de ce type
    document.addEventListener('DOMContentLoaded', () => {
        document
            .querySelectorAll('.section-video-scroll[data-section-type="w-video-scroll"]')
            .forEach((section) => {
                // Check if using frame sequence or video
                const canvas = section.querySelector('.video-scroll__canvas');
                if (canvas) {
                    initScrollFrameSequence(section);
                } else {
                    initScrollVideo(section);
                }
            });
    });

    // Hot-swap si Shopify réinjecte la section en mode thème-editor
    document.addEventListener('shopify:section:load', (evt) => {
        const section = document.getElementById(`section-${evt.detail.sectionId}`);
        if (section && section.matches('.section-video-scroll')) {
            const canvas = section.querySelector('.video-scroll__canvas');
            if (canvas) {
                initScrollFrameSequence(section);
            } else {
                initScrollVideo(section);
            }
        }
    });
})();

(function () {
    // Sélecteur du conteneur Swiper dans la section
    const SECTION_SELECTOR = '.section-video-scroll';
    const SWIPER_SELECTOR = '.swiper';

    // Stockage des instances pour éviter les doubles inits
    const instances = new WeakMap();

    function initSlider(root = document) {
        const sections = root.querySelectorAll(SECTION_SELECTOR);
        sections.forEach((section) => {
            const swiperEl = section.querySelector(SWIPER_SELECTOR);
            if (!swiperEl || instances.has(swiperEl)) return;

            try {
                const swiper = new Swiper(swiperEl, {
                    // Base mobile-first
                    slidesPerView: 1,
                    spaceBetween: 16,
                    pagination: { el: section.querySelector('.swiper-pagination'), clickable: true },
                    // navigation: {
                    //   nextEl: section.querySelector('.swiper-button-next'),
                    //   prevEl: section.querySelector('.swiper-button-prev')
                    // },

                    observeParents: true,
                    observer: true,
                    watchOverflow: true,
                    // Responsive
                    breakpoints: {
                        430: {
                            // Toujours 1 up to 749px
                            slidesPerView: 1
                        },
                        750: {
                            slidesPerView: 3
                        },
                        1100: {
                            slidesPerView: 4
                        }
                    }
                });

                instances.set(swiperEl, swiper);
            } catch (e) {
                // Swiper non chargé ?
                console.warn('[video-scroll] Swiper introuvable ou erreur d’init', e);
            }
        });
    }

    // Init au chargement
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initSlider());
    } else {
        initSlider();
    }

    // Support éditeur Shopify (rechargement de section)
    document.addEventListener('shopify:section:load', (e) => {
        if (!e?.target) return;
        initSlider(e.target);
    });
    document.addEventListener('shopify:section:select', (e) => {
        if (!e?.target) return;
        initSlider(e.target);
    });
})();
